<template>
    <div class="banner">
        <div class="banner-content">
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-6">
                    <input type="text" maxlength="250" placeholder="Story Title" v-model="title" class="form-control">
                    <input type="text" maxlength="250" placeholder="Story Category" v-model="category" class="form-control">
                    <input type="text" maxlength="250" placeholder="First Line of Story" v-model="line" class="form-control">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 col-sm-10 col-md-6">
                    <button v-if="!pendingTransaction" @click="newStory" class="btn btn-primary">Create New Story</button>
                    <button v-else class="btn btn-secondary">Please wait ...</button>
                </div>
            </div>                          
        </div>
        <div class="arrow-container">
            <Arrow sectionId="#home-content"/>
        </div>
    </div>
</template>

<script type="text/javascript">
import { db, auth } from '../../util/firebase';
import { mapGetters } from "vuex";
import Arrow from "../Arrow";
import InputTag from 'vue-input-tag'

export default {
    name: 'the-banner',
    components: { Arrow, InputTag },
    data () {
        return {
            title: '',
            category: '',
            line: '',
            disabled: false
        }
    },
    computed: {
        ...mapGetters({
            pendingTransaction: 'getPendingTransaction'
        })
    },
    methods: {
        newStory () {

            const title = this.title;
            const category = this.category;
            const line = this.line;

            if (title.replace(/\s/g, '') == '') {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please provide a title!'
                });

                return;
            }

            if (category.replace(/\s/g, '') == '') {
                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please provide a category!'
                });

                return;
            }

            if (line.replace(/\s/g, '') == '') {

                this.$notify({
                    group: "app",
                    title: "Warning!",
                    text: 'Please provide a line!'
                });

                return;
            }
        
            this.$store.commit('updatePendingTransaction', { status: true });            
            this.$store.dispatch('newStory', { title, category, line }).then((response) => {
                
                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Congrats!",
                        text: 'You made a new story!'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                }

                // Remove pending
                this.$store.commit('updatePendingTransaction', { status: false });

                this.title = '';
                this.category = '';
                this.line = '';

            });    
        }
    }
}
</script>

<style scoped lang="less">
.form-control, .btn {
    border-radius: 0;
    padding: 15px 25px;
}

.vue-input-tag-wrapper {
    padding: 7px 20px 2px!important;
}

.banner {
    height: 100vh;
    border-bottom: 3px solid #88929B;
    background: url(/static/story_bg.jpg);
    background-size: cover;
    padding-top: 100px;
    text-align: center;
    
    .arrow-container {
        position: absolute;
        bottom: 3vh;
        width: 100%;
    }

    .banner-content {
        margin-top: 20vh;

        h1 {
            color: #fff;
            margin-bottom: 40px;
        }

        .btn {
            width: 100%;
            margin-top: 10px;

            &.btn-primary {
                border-color: transparent;
            }
        }

        .btn-group {
            margin-bottom: 20px;

            .btn {
                background: #fff;
                color: #000;

                &.selected {
                    background: #727082;
                    color: #fff;
                }
            }
        }
    }
}

// Phone device
@media only screen and (max-width: 480px) {
    .btn-group {
        display: block;
        .btn {
            width: 100%!important;
        }
    }

    .banner-content {
        margin-top: 15vh!important;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/TheBanner.vue